import { navigation, tenants } from './navigation/navigation.reducers';
import { upcomingPublications, upcomingPublicationFilters } from '../upcomingPublications/upcomingPublication.reducers';
import { publications, publicationFilters } from '../publications/publication.reducers';
import { performanceMetrics, performanceMetricFilters } from '../performance/performance.reducers';

const initialState = {
    navigation: {},
    tenants: {},
    publications: {},
    publicationFilters: {},
    upcomingPublications:{},
    upcomingPublicationFilters:{},
    performanceMetrics: {},
    performanceMetricFilters: {}
};

export default function appReducer(state = initialState, action) {
    let newState = {};
    Object.assign(newState, state, {
        navigation: navigation(state.navigation, action),
        tenants: tenants(state.tenants, action),
        publications: publications(state.publications, action),
        publicationFilters: publicationFilters(state.publicationFilters, action),
        upcomingPublications: upcomingPublications(state.upcomingPublications, action),
        upcomingPublicationFilters: upcomingPublicationFilters(state.upcomingPublicationFilters, action),
        performanceMetrics: performanceMetrics(state.performanceMetrics, action),
        performanceMetricFilters: performanceMetricFilters(state.performanceMetricFilters, action)
    });
    return newState;
}